import "../assets/scss/components/_message-card-animation.scss";
import Birthday from "../assets/images/cards/svg/happy-birthday.svg";
import Christmas from "../assets/images/cards/christmas.png";
import GetWellSoon from "../assets/images/cards/svg/get-well-soon.svg";
import MothersDay from "../assets/images/cards/mothers-day-personalised-card.jpg";
import PhotoUpload from "../assets/images/cards/svg/photo-upload.svg";
import Sympathy from "../assets/images/cards/svg/sympathy.svg";
import ThankYou from "../assets/images/cards/svg/thank-you.svg";
import { useAppContext } from "../contexts/AppContext";
import { useAppStore } from "../stores/AppStore";

export const MessageCardAnimation = () => {
	const appData = useAppContext();
	const { peakConfigs: storedPeakConfigs } = useAppStore(({ peakConfigs }) => ({ peakConfigs }));
	const peakConfigs = appData?.peakConfigs || storedPeakConfigs;

	const tempImages = [
		{
			image: Birthday,
			text: "Birthday Cards",
		},
		{
			image: Sympathy,
			text: "Sympathy Cards",
		},
		{
			image: ThankYou,
			text: "Thank You Cards",
		},
		{
			image: GetWellSoon,
			text: "Get Well Soon Cards",
		},
		{
			image: PhotoUpload,
			text: "Photo Upload Cards",
		},
	];

	if (peakConfigs?.MOTHERS_DAY && 1 == 2) {
		tempImages.splice(0, 1, {
			image: MothersDay,
			text: "Mother's Day Cards",
		});
	}

	if (peakConfigs?.AUTUMN || peakConfigs?.CHRISTMAS) {
		tempImages.splice(1, 1, {
			image: Christmas,
			text: "Christmas Cards",
		});
	}

	const images = tempImages;

	return (
		<div className="message-card-images">
			<div className="images-container">
				{images.map((image, i) => {
					return (
						<div key={i} className="image-container">
							<img src={image.image} alt="Message Card" />
							<span>{image.text}</span>
						</div>
					);
				})}
			</div>
		</div>
	);
};
